import { Grid } from '@material-ui/core';
import React from 'react';
import { useBrand } from '../../../hooks/useBrand';
import Logo from '../../elements/Logo';

const BrandedCardLogo = () => {
    const { logo } = useBrand();
    return (
        <Grid item justify='center' xs={12}>
            <Logo size={logo.size ? logo.size : 200} imageUri={logo.uri} altText={logo.altText} />
        </Grid>
    );
};
BrandedCardLogo.displayName = 'BrandedCardLogo';
export default BrandedCardLogo;
